import * as moment from 'moment';
import { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import * as DateTimeModule from 'react-datetime';
import { IBloodDrawConfirmationContract } from '@nkr/models/index';
import { DISPLAY_FORMAT, STORAGE_FORMAT, validateSerologyDate } from '@nkr/utils/blood-draw-validation';
import { styles } from './styles';

interface IProps {
    item: IBloodDrawConfirmationContract,
    onConfirm: (contract: IBloodDrawConfirmationContract) => void
}

const DateTime = (DateTimeModule as any).default || DateTimeModule;

// The alert surfaces draws scheduled from today onward, so today is a legal answer here - hence
// allowToday. The 5-7 window and the surgery-within-7-days relaxation come from the shared
// validator, so this row and the XM accept modal cannot drift apart again.
const isAcceptable = (date: moment.Moment, targetSurgeryDate: string): boolean =>
    validateSerologyDate(date, targetSurgeryDate, true).isValid;

const ConfirmSerologyBloodDrawRow = (props: IProps) => {
    const [drawDate, setDrawDate] = useState(moment(props.item.scheduledBloodDrawDate).format(STORAGE_FORMAT));

    const validation = drawDate
        ? validateSerologyDate(moment(drawDate, STORAGE_FORMAT), props.item.targetSurgeryDate, true)
        : { isValid: false, error: 'Scheduled blood draw date is required.' };

    const handleDrawDateChange = (value: moment.Moment | string) => {
        if (moment.isMoment(value)) {
            setDrawDate(value.format(STORAGE_FORMAT));
            return;
        }

        const parsed = moment(value, DISPLAY_FORMAT, true);
        setDrawDate(parsed.isValid() ? parsed.format(STORAGE_FORMAT) : '');
    };

    const handleConfirm = () => {
        props.onConfirm({ ...props.item, scheduledBloodDrawDate: drawDate });
    };

    return (
        <tr>
            <td>{props.item.swapNumber}</td>
            <td>
                {props.item.donorCenterAlias}
                {props.item.rdnCenterId > 0 && <> (<span style={styles.rdnCenterAlias}>{props.item.rdnCenterAlias}</span>)</>}
            </td>
            <td>{props.item.donorAlias}</td>
            <td>{props.item.recipientCenterAlias}</td>
            <td>{props.item.recipientAlias}</td>
            <td>{moment(props.item.targetSurgeryDate).format('M/D/YYYY')}</td>
            <td>
                <DateTime
                    value={drawDate ? moment(drawDate, STORAGE_FORMAT) : null}
                    dateFormat={DISPLAY_FORMAT}
                    timeFormat={false}
                    strictParsing={true}
                    isValidDate={(currentDate: moment.Moment) => isAcceptable(currentDate, props.item.targetSurgeryDate)}
                    onChange={handleDrawDateChange}
                    inputProps={{
                        className: 'form-control',
                        placeholder: DISPLAY_FORMAT
                    }}
                    closeOnSelect={true}
                />
                <Alert hidden={validation.isValid} bsStyle='warning' style={styles.validationAlert}>
                    {validation.error}
                </Alert>
            </td>
            <td>
                <Button bsStyle='primary' bsSize='xs' disabled={!validation.isValid} onClick={handleConfirm}>
                    Click to Confirm
                </Button>
            </td>
        </tr>
    );
};

export default ConfirmSerologyBloodDrawRow;
